import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Padding } from 'components/base/layout-components';

export const TooltipList = ({
  children,
  tooltipItems = [],
  title = '',
  placement = 'top-start'
}) => {
  return (
    <Tooltip
      interactive
      placement={placement}
      title={
        <Padding t='small' b='small' r='x-small' l='x-small' width='20rem'>
          {tooltipItems.map((val, i) => (
            <div key={i}>{val}</div>
          ))}
          {title}
        </Padding>
      }
    >
      {children}
    </Tooltip>
  );
};
